// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b9fe8e72","455":"bcc200de","977":"ee9646da"}[chunkId] + ".chunk.js";
};